import React, { useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import { TextField, InputAdornment } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { fetchUserSkills } from "../../../services/api/user";
import { useParams } from "react-router-dom";
import AddSkillsModal from "../../CompleteYourProfile/components/AddSkillsModal";
import { UserType } from "../../../utils/enum";
import BaseTooltip from "../../../components/ui/BaseTooltip";
import useAuth from "../../../hooks/useAuth";

const AddEditSkills = ({ userId }) => {
  const { authRole } = useAuth();
  const [isAddSkillsModalOpen, setIsAddSkillsModalOpen] = useState(false);

  const {
    isPending: isUserSkillsLoading,
    error: isUserSkillsError,
    refetch: refetchUserSkills,
    data: userSkillsData,
  } = useQuery({
    queryKey: ["userSkillsData"],
    queryFn: () => fetchUserSkills(userId),
    retry: 2,
    enabled: !!userId,
  });
  return (
    <div className="mt-6 border-b pb-4">
      <div className="bg-light px-4 py-2 rounded-md flex justify-between items-center ">
        <h6 className="text-dark font-normal">Skills</h6>
        <i
          className="fa-light fa-pencil text-gray-900 cursor-pointer"
          onClick={() => setIsAddSkillsModalOpen(true)}
        ></i>
      </div>
      <div className="flex flex-wrap gap-4 mt-4 ml-4">
        {userSkillsData?.data?.map((skill) => (
          <p className="px-4 py-1 bg-light rounded-sm" key={skill.id}>
            {skill?.subCategory}
            {(UserType.ADMIN === authRole || UserType.CLIENT === authRole) && skill?.isVerified && (
              <BaseTooltip content={<p className="text-white">Verified</p>}>
                <i class="fa-solid text-primary fa-circle-check ml-2"></i>
              </BaseTooltip>
            )}
          </p>
        ))}
      </div>

      <AddSkillsModal
        close={setIsAddSkillsModalOpen}
        open={isAddSkillsModalOpen}
        refetchUserSkills={refetchUserSkills}
        skills={userSkillsData?.data}
        userId={userId}
      />
    </div>
  );
};

export default AddEditSkills;
